/* eslint-disable no-unused-vars */
import { useState, useEffect, useCallback } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Backdrop, Box, Breadcrumbs, Button, CircularProgress, Container, FormControlLabel, Grid, Link, Switch, Typography } from '@material-ui/core';
import { customerApi } from '../../../api/customerApi';
import useMounted from '../../../hooks/useMounted';
import ChevronRightIcon from '../../../icons/ChevronRight';
import useSettings from '../../../hooks/useSettings';
import gtm from '../../../lib/gtm';
import useAuth from '../../../hooks/useAuth';
import CustomerNewProspectsListTable from './CustomerNewProspectsListTable';
import PlusIcon from '../../../icons/Plus';
import UploadIcon from '../../../icons/Upload';
import { DownloadIcon } from 'lucide-react';
import ImportModal from '../../CSVImport/ImportModal';
import ExportDialog from './ExportDialog';
import UsersIcon from '../../../icons/Users';

const CustomerNewProspects = () => {
  const mounted = useMounted();
  const { settings } = useSettings();
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [loadingFilter, setLoadingFilter] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [numberCustomers, setNumberCustomers] = useState(0);
  const [usersCampaign, setUsersCampaign] = useState([]);
  const [usersRelance, setUsersRelance] = useState([]);
  const [modeRelance, setModeRelance] = useState(false);
  const [relance, setRelance] = useState(false);
  const [endSessions, setEndSessions] = useState([]);
  const [customersEndSessions, setCustomersEndSessions] = useState([]);
  const [choiceTabProfession, setChoiceTabProfession] = useState('');
  const [choiceSort, setChoiceSort] = useState('lastname|asc');
  const [choiceSource, setChoiceSource] = useState('');
  const [choiceCampaign, setChoiceCampaign] = useState('');
  const [choiceCallTrack, setChoiceCallTrack] = useState('');
  const [choiceNewCallTrack, setChoiceNewCallTrack] = useState('');
  const [choiceCallTrackRelance, setChoiceCallTrackRelance] = useState('');
  const [choiceAvancement, setChoiceAvancement] = useState('');
  const [choiceEndSession, setChoiceEndSession] = useState('');
  const [importModalOpen, setImportModalOpen] = useState(false);
  const [exportModalOpen, setExportModalOpen] = useState(false);

  function initRelance() {
    const rel = {};
    usersRelance.forEach((element) => {
      rel[element.id] = null;
    });
    rel.empty = null;
    return rel;
  }

  const [choiceRelance, setChoiceRelance] = useState(initRelance);
  const [query, setQuery] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(25);

  useEffect(() => {
    gtm.push({ event: 'page_view' });
  }, []);

  const location = useLocation();

  useEffect(() => {
    // Les choice permettent de garder les choix de filtre même en changeant de page
    let tempChoiceTabProfession = window.localStorage.getItem('choiceTabProfession');
    tempChoiceTabProfession = tempChoiceTabProfession === null ? 'all' : window.localStorage.getItem('choiceTabProfession').replaceAll('"', '');
    setChoiceTabProfession(tempChoiceTabProfession);
    let tempChoiceSort = window.localStorage.getItem('choiceSort');
    tempChoiceSort = tempChoiceSort === null ? 'lastname|asc' : window.localStorage.getItem('choiceSort').replaceAll('"', '');
    setChoiceSort(tempChoiceSort);
    let tempChoiceSource = window.localStorage.getItem('choiceSource');
    tempChoiceSource = tempChoiceSource === null ? '' : window.localStorage.getItem('choiceSource').replaceAll('"', '');
    setChoiceSource(tempChoiceSource);
    let tempChoiceCampaign = window.localStorage.getItem('choiceCampaign');
    tempChoiceCampaign = tempChoiceCampaign === null ? '' : window.localStorage.getItem('choiceCampaign').replaceAll('"', '');
    setChoiceCampaign(tempChoiceCampaign);
    let tempChoiceCallTrack = window.localStorage.getItem('choiceCallTrack');
    tempChoiceCallTrack = tempChoiceCallTrack === null ? '' : window.localStorage.getItem('choiceCallTrack').replaceAll('"', '');
    setChoiceCallTrack(tempChoiceCallTrack);
    let tempChoiceNewCallTrack = window.localStorage.getItem('choiceNewCallTrack');
    tempChoiceNewCallTrack = tempChoiceNewCallTrack === null ? '' : window.localStorage.getItem('choiceNewCallTrack').replaceAll('"', '');
    setChoiceNewCallTrack(tempChoiceNewCallTrack);
    let tempChoiceCallTrackRelance = window.localStorage.getItem('choiceCallTrackRelance');
    tempChoiceCallTrackRelance = tempChoiceCallTrackRelance === null ? '' : window.localStorage.getItem('choiceCallTrackRelance').replaceAll('"', '');
    setChoiceCallTrackRelance(tempChoiceCallTrackRelance);
    let tempChoiceAvancement = window.localStorage.getItem('choiceAvancement');
    tempChoiceAvancement = tempChoiceAvancement === null ? '' : window.localStorage.getItem('choiceAvancement').replaceAll('"', '');
    setChoiceAvancement(tempChoiceAvancement);
    let tempChoiceEndSession = window.localStorage.getItem('choiceEndSession');
    tempChoiceEndSession = tempChoiceEndSession === null ? '' : window.localStorage.getItem('choiceEndSession').replaceAll('"', '');
    setChoiceEndSession(tempChoiceEndSession);
    let tempChoiceRelance = window.localStorage.getItem('choiceRelance');
    tempChoiceRelance = tempChoiceRelance === null ? '' : window.localStorage.getItem('choiceRelance').replaceAll('"', '');
    setChoiceRelance(tempChoiceRelance);
  }, []);

  const getProspect = useCallback(async () => {
    try {
      let data = [];
      let tempChoiceProfession = window.localStorage.getItem('choiceTabProfession');
      tempChoiceProfession = tempChoiceProfession === null ? 'all' : window.localStorage.getItem('choiceTabProfession').replaceAll('"', '');
      let tempChoiceSource = window.localStorage.getItem('choiceSource');
      tempChoiceSource = tempChoiceSource === null ? 'all' : window.localStorage.getItem('choiceSource').replaceAll('"', '');
      let tempChoiceCampaign = window.localStorage.getItem('choiceCampaign');
      tempChoiceCampaign = tempChoiceCampaign === null ? 'all' : window.localStorage.getItem('choiceCampaign').replaceAll('"', '');
      let tempChoiceCallTrack = window.localStorage.getItem('choiceCallTrack');
      tempChoiceCallTrack = tempChoiceCallTrack === null ? 'all' : window.localStorage.getItem('choiceCallTrack').replaceAll('"', '');
      let tempChoiceNewCallTrack = window.localStorage.getItem('choiceNewCallTrack');
      tempChoiceNewCallTrack = tempChoiceNewCallTrack === null ? 'all' : window.localStorage.getItem('choiceNewCallTrack').replaceAll('"', '');
      let tempChoiceCallTrackRelance = window.localStorage.getItem('choiceCallTrackRelance');
      tempChoiceCallTrackRelance = tempChoiceCallTrackRelance === null ? 'all' : window.localStorage.getItem('choiceCallTrackRelance').replaceAll('"', '');
      let tempChoiceAvancement = window.localStorage.getItem('choiceAvancement');
      tempChoiceAvancement = tempChoiceAvancement === null ? 'all' : window.localStorage.getItem('choiceAvancement').replaceAll('"', '');
      let tempChoiceEndSession = window.localStorage.getItem('choiceEndSession');
      tempChoiceEndSession = tempChoiceEndSession === null ? 'all' : window.localStorage.getItem('choiceEndSession').replaceAll('"', '');
      let tempChoiceRelance = window.localStorage.getItem('choiceRelance');
      tempChoiceRelance = tempChoiceRelance === null ? 'all' : window.localStorage.getItem('choiceRelance').replaceAll('"', '');
      
      setLoading(true);
      if (location.pathname === '/dashboard/prospects') {
        mounted.current = true;
        if (query === '' && tempChoiceProfession === 'all' && user.access_level === 0) {
          // aucun résultat retourné
          setCustomers([]);
          setNumberCustomers(0);
          setUsersCampaign([]);
          setUsersRelance([]);
        } else {
          data = await customerApi.getProspect(window.localStorage.getItem('accessToken'), query, choiceSort, tempChoiceSource, tempChoiceCampaign, tempChoiceCallTrack,
            tempChoiceNewCallTrack, tempChoiceCallTrackRelance, tempChoiceAvancement, tempChoiceEndSession, tempChoiceRelance, tempChoiceProfession, limit, page, modeRelance);
          setCustomers(data.customers);
          setNumberCustomers(data.numberCustomers);
          setUsersCampaign(data.usersCampaign);
          setUsersRelance(data.usersRelance);
        }
        setCustomersEndSessions(data.customers_end_sessions || []);
      } else if (location.pathname === '/dashboard/campagne') {
        mounted.current = true;
        data = await customerApi.getCustomersCampagne(window.localStorage.getItem('accessToken'), query, choiceSort, tempChoiceSource, tempChoiceCampaign, tempChoiceCallTrack,
          tempChoiceNewCallTrack, tempChoiceCallTrackRelance, tempChoiceAvancement, tempChoiceEndSession, tempChoiceRelance, tempChoiceProfession, limit, page, modeRelance);
        setCustomers(data.customers);
      }

      if (mounted.current) {
        setEndSessions(data.end_sessions || []);
        setLoading(false);
        setLoadingFilter(false);

        if (user.id_service === 4) {
          setRelance(true);
        }
      }
    } catch (err) {
      console.error(err);
    }
  }, [mounted, location]);

  useEffect(() => {
    getProspect();
  }, [getProspect]);

  return (
    <>
      <Helmet>
        <title>Tableau de bord: Liste des prospects | Syndays</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 4,
          transition: 'all 0.3s'
        }}
      >
        <Container maxWidth={settings.compact ? 'xl' : false}>
          {/* ── Hero Header ── */}
          <Box
            sx={{
              mb: 4,
              p: 3.5,
              borderRadius: '24px',
              border: '1px solid',
              borderColor: 'rgba(226, 232, 240, 0.8)',
              background: 'linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(241,245,249,0.7) 100%)',
              backdropFilter: 'blur(20px)',
              boxShadow: '0 4px 24px rgba(0,0,0,0.04)',
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: { xs: 'flex-start', md: 'center' },
              justifyContent: 'space-between',
              gap: 3,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
              <Box
                sx={{
                  width: 56,
                  height: 56,
                  borderRadius: '16px',
                  background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 8px 20px rgba(59, 130, 246, 0.3)',
                  flexShrink: 0,
                }}
              >
                <UsersIcon style={{ color: '#fff', fontSize: '1.7rem', width: 28, height: 28 }} />
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontWeight: 800,
                    fontSize: '1.5rem',
                    color: 'text.primary',
                    letterSpacing: '-0.02em',
                    lineHeight: 1.2,
                  }}
                >
                  Liste des prospects
                </Typography>
                <Breadcrumbs
                  aria-label="breadcrumb"
                  separator={<ChevronRightIcon fontSize="small" />}
                  sx={{ mt: 1, mb: 1 }}
                >
                  <Link
                    color="textSecondary"
                    component={RouterLink}
                    to="/dashboard"
                    variant="subtitle2"
                    sx={{ textDecoration: 'none', '&:hover': { color: '#3b82f6' } }}
                  >
                    Tableau de bord
                  </Link>
                  <Link
                    color="textSecondary"
                    component={RouterLink}
                    to="/dashboard"
                    variant="subtitle2"
                    sx={{ textDecoration: 'none', '&:hover': { color: '#3b82f6' } }}
                  >
                    Gestion
                  </Link>
                  <Typography
                    color="textPrimary"
                    variant="subtitle2"
                    sx={{ fontWeight: 600 }}
                  >
                    Prospects
                  </Typography>
                </Breadcrumbs>
              </Box>
            </Box>
            
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
              <Button
                color="primary"
                component={RouterLink}
                startIcon={<PlusIcon fontSize="small" />}
                to="/dashboard/customers/create"
                sx={{
                  background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                  boxShadow: '0 4px 12px 0 rgba(59, 130, 246, 0.25)',
                  color: '#fff',
                  borderRadius: '12px',
                  px: 3,
                  py: 1.2,
                  textTransform: 'none',
                  fontWeight: 600,
                  '&:hover': {
                    background: 'linear-gradient(135deg, #2563eb 0%, #1e40af 100%)',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 6px 16px 0 rgba(59, 130, 246, 0.35)'
                  },
                  transition: 'all 0.2s ease-in-out'
                }}
                variant="contained"
              >
                Ajouter un prospect
              </Button>
              
              {(user.id_service === 0 || user.id_service === 4) && (
                <Button
                  color="primary"
                  startIcon={<UploadIcon fontSize="small" />}
                  onClick={() => setImportModalOpen(true)}
                  sx={{
                    borderRadius: '12px',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    px: 2.5,
                    py: 1.2,
                    textTransform: 'none',
                    fontWeight: 600,
                    '&:hover': {
                      backgroundColor: 'rgba(59, 130, 246, 0.04)',
                      borderColor: '#3b82f6',
                      transform: 'translateY(-1px)'
                    },
                    transition: 'all 0.2s ease-in-out'
                  }}
                  variant="outlined"
                >
                  Importer des contacts
                </Button>
              )}
              
              {user.id_service === 0 && user.access_level === 0 && (
                <Button
                  color="primary"
                  startIcon={<DownloadIcon fontSize="small" />}
                  onClick={() => setExportModalOpen(true)}
                  sx={{
                    borderRadius: '12px',
                    border: '1px solid rgba(148, 163, 184, 0.3)',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    px: 2.5,
                    py: 1.2,
                    textTransform: 'none',
                    fontWeight: 600,
                    color: '#64748b',
                    '&:hover': {
                      backgroundColor: 'rgba(241, 245, 249, 0.8)',
                      borderColor: '#94a3b8',
                      transform: 'translateY(-1px)'
                    },
                    transition: 'all 0.2s ease-in-out'
                  }}
                  variant="outlined"
                >
                  Exporter
                </Button>
              )}
            </Box>
          </Box>
          <Box sx={{ mt: 1 }}>
            <CustomerNewProspectsListTable
              customers={customers} // Liste des apprenants
              usersCampaign={usersCampaign} // Utilisateurs à assigner en Campagne
              isRelance={relance} // Permet de savoir si l'utilisateur fait partie exclusivement du service Relance
              modeRelance={modeRelance} // Permet de savoir si on est en mode Relance pour l'administrateur
              usersRelance={usersRelance} // Utilisateurs à assigner du service relance
              endSessions={endSessions} // Date de toutes les fins de sessions en bdd
              customersEndSessions={customersEndSessions} // Tableau de fins de sessions des apprenants
              choiceTabProfession={choiceTabProfession} // si préfixe choice, permet de garder en mémoire le changement de filtre
              choiceSort={choiceSort}
              choiceSource={choiceSource}
              choiceCampaign={choiceCampaign}
              choiceCallTrack={choiceCallTrack}
              choiceNewCallTrack={choiceNewCallTrack}
              choiceCallTrackRelance={choiceCallTrackRelance}
              choiceAvancement={choiceAvancement}
              choiceEndSession={choiceEndSession}
              query={query}
              setQuery={setQuery}
              setCustomers={setCustomers}
              numberCustomers={numberCustomers}
              setNumberCustomers={setNumberCustomers}
              loading={loading}
              loadingFilter={loadingFilter}
              page={page}
              setPage={setPage}
              limit={limit}
              setLimit={setLimit}
              relance={choiceRelance}
              setRelance={setChoiceRelance}
            />
            <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={loading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </Box>
        </Container>
      </Box>
      <ImportModal
        open={importModalOpen}
        onClose={() => setImportModalOpen(false)}
      />
      <ExportDialog
        open={exportModalOpen}
        onClose={() => setExportModalOpen(false)}
      />
    </>
  );
};

export default CustomerNewProspects;

